import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PAGES = [
  ["/report-pages/cover.webp", "Cover page of the Disha sample career discovery report", "left-0 top-6 rotate-[-5deg] w-[52%]"],
  ["/report-pages/interest.webp", "Sample report page showing the student's interest profile chart", "left-[24%] top-0 rotate-[1.5deg] w-[52%] z-10"],
  ["/report-pages/colleges.webp", "Sample report page listing colleges and universities in India to explore", "right-0 top-10 rotate-[5deg] w-[50%] z-20"],
];

const BENEFITS = [
  ["#2F6F73", "Your strengths, in words you'll recognise", "Clear, encouraging language about what you do well, and what you can grow next."],
  ["#3E6FA3", "Career paths worth exploring", "Areas that fit your interests, with real careers inside each one."],
  ["#D96A4E", "Courses and colleges in India", "Courses, colleges and universities worth a closer look, from Class 9."],
  ["#5E8C4F", "A conversation guide for the family", "Simple questions to talk through together at home."],
  ["#B7791F", "A one-on-one chat with a career counsellor, on request", "Write to us and we'll set up a session with one of our counsellors."],
];

export default function ReportPreview() {
  return (
    <section id="report" className="ds-section bg-ds-creamalt overflow-hidden" data-testid="landing-report-preview">
      <div className="container-x grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1" data-reveal>
          <div className="relative aspect-[4/3.4] w-full" data-testid="report-preview-mock">
            {PAGES.map(([src, alt, pos]) => (
              <figure key={src} className={`absolute ${pos} rounded-[10px] bg-white p-1.5 border border-ds-plum/10 shadow-[0_22px_44px_-22px_rgba(79,3,65,0.45)] transition-transform duration-300 hover:-translate-y-2`}>
                <img src={src} alt={alt} className="w-full rounded-[6px]" loading="lazy" />
              </figure>
            ))}
          </div>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2" data-reveal>
          <h2 className="ds-h2">A report you'll want to read together.</h2>
          <p className="mt-4 text-[17px] text-ds-inksoft leading-relaxed">Warm, clear and personal. Written to spark a conversation, not to hand down a verdict.</p>
          <ul className="mt-8 space-y-5">
            {BENEFITS.map(([c, title, text], i) => (
              <li key={title} className="flex gap-4" data-testid={`report-benefit-${i + 1}`}>
                <span className="mt-1.5 h-3.5 w-3.5 shrink-0 rounded-full" style={{ backgroundColor: c }} />
                <div>
                  <h3 className="font-display text-lg font-semibold text-ds-plumdeep">{title}</h3>
                  <p className="mt-0.5 text-[15px] text-ds-inksoft leading-relaxed">{text}</p>
                </div>
              </li>
            ))}
          </ul>
          <Link to="/sample-report" className="ds-btn mt-9 bg-ds-plum text-white hover:bg-[#3d0232]" data-testid="view-sample-report-button">View the full sample report <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </section>
  );
}
